import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { BehaviorSubject } from 'rxjs'

export enum Theme {
  light,
  dark,
  hybrid,
}

export const defaultTheme = Theme.light
const theme$ = new BehaviorSubject<Theme>(defaultTheme)
export const themeContext = createContext(defaultTheme)

type UseThemeResult = [Theme, (theme: Theme) => void]

export default function useTheme(): UseThemeResult {
  const theme = useContext(themeContext)
  const dispatch = useCallback((theme: Theme) => theme$.next(theme), [])
  const [currentTheme, setCurrentTheme] = useState<Theme>(theme)

  useEffect(() => {
    const sub = theme$.subscribe(setCurrentTheme)
    return () => sub.unsubscribe()
  }, [])

  useEffect(() => {
    dispatch(theme)
  }, [dispatch, theme])

  return [currentTheme, dispatch]
}
